import classNames from "classnames";
import Clickable from "components/Clickable";
import { truthyPathMatch, useCurrentPath } from "helpers/utils";
import { useEffect, useRef } from "react";

import { NavBarProps } from "./interfaces";

import styles from "./horizontal-nav-bar.module.scss";

export const HorizontalNavBar = ({ cmsData: { nav_items } }: NavBarProps) => {
    const path = useCurrentPath();
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer) {
            const activeItem = scrollContainer.querySelector(
                `a.${styles.active}`,
            ) as HTMLAnchorElement | null;
            if (activeItem) {
                scrollContainer.scrollTo({
                    behavior: "smooth",
                    left: activeItem.offsetLeft,
                });
            }
        }
    }, []);

    return (
        <nav className={styles.nav}>
            <div className={styles.inner} ref={scrollContainerRef}>
                {nav_items.map((item) => (
                    <Clickable
                        key={item.id}
                        cmsLink={item.value.link}
                        className={classNames({
                            [styles.link]: true,
                            [styles.active]: truthyPathMatch(
                                path,
                                item.value.link.url,
                            ),
                        })}
                    >
                        {item.value.text}
                    </Clickable>
                ))}
            </div>
        </nav>
    );
};
